import React from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Headline } from "../../../../Components/Text";
import { Player } from "../../../../../components/molecules/clip/player";
import { LoadingSkeleton } from "../../../../Components/Skeloton";
import { HiPlay } from "react-icons/hi";
import { getClipTitle } from "../../../../Utilities/Clip";
import { clipHasStudio, formatNumber } from "../../../../Utilities/Clip";
import { Owner } from "../../../../Components/Clip/Components/Owner";
import { getDisplayName } from "../../../../Utilities/Clip";
import { getAvatarImage } from "../../../../Utilities/User";
import { ClipCardDescription } from "../../../../Components/Clip/Components/ClipDescription";

export function CardClips({
  cardClips,
  clipsLoading,
  allstarUser,
  // mutateFollowers,
  isMontage,
}: any) {
  // const followUnfollow = (data: any): void => {
  //   mutateFollowers(data);
  //   return;
  // };

  if (clipsLoading) {
    return (
      <>
        {/* <Divider /> */}
        <StyledHeadline mt={7} mb={4}>
          <LoadingSkeleton
            height={30}
            width={130}
            style={{ borderRadius: "10px", flex: 1 }}
          />
        </StyledHeadline>
        <ClipGrid>
          {[1, 1].map((x, index) => {
            return (
              <>
                <LoadingSkeleton
                  height={300}
                  style={{ borderRadius: "10px", flex: 1 }}
                />
              </>
            );
          })}
        </ClipGrid>
      </>
    );
  }

  return (
    <>
      {/* <Divider mb={6} /> */}
      <Flex mb={4} mt={7} alignItems={"center"}>
        <StyledIcon />
        <StyledHeadline>See it in action</StyledHeadline>
      </Flex>

      <ClipGrid>
        {cardClips.map((clip: any, index: any) => {
          const isOwnClip = clip.user._id === allstarUser?.user?._id;
          const to = isMontage
            ? `/montage?montage=${clip.shareId}`
            : `/clip?clip=${clip.shareId}`;
          return (
            <CardClipsFlex key={index}>
              <StyledPlayer>
                <TypedPlayer
                  cardClips
                  clip={clip}
                  loop={true}
                  autoplay={false}
                />
              </StyledPlayer>

              <ClipCardDescription
                views={clip.views ? formatNumber(clip.views) : 0}
                height="100%"
                clip={undefined}
                to={to}
                mt={3}
                onClick={undefined}
                classification={undefined}
                truncate={undefined}
                alignment={undefined}
                displayMeta={false}
                isMontage={isMontage}
              />
              <Owner
                avatarSize="nav"
                loading={false}
                ownerId={clip.user._id}
                user={clip.user}
                displayName={getDisplayName(clip)}
                isOwnClip={isOwnClip}
                userRank={clip.user.rank}
                hideTitle
                avatar={getAvatarImage(clip.user)}
                allstarUser={allstarUser}
                followUnfollow={undefined}
                setFollowModal={undefined}
                hideFollow={true}
                mt={3}
              />
            </CardClipsFlex>
          );
        })}
      </ClipGrid>
    </>
  );
}
const StyledHeadline = styled(Headline)`
  font-weight: 600;
`;

const TypedPlayer = styled<any>(Player)`
  height: inherit;
  width: inherit;
`;

const ClipGrid = styled(Flex)<any>`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 1fr 1fr;
  list-style: none;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    grid-template-columns: 1fr;
  }
`;

const StyledPlayer = styled(Flex)`
  width: 100%;
`;

const StyledIcon = styled(HiPlay)`
  color: ${({ theme }) => theme.colors.envy};
  margin-right: ${({ theme }) => theme.space[2]}px;
  width: 32px;
  height: 32px;
`;

const CardClipsFlex = styled(Flex)<any>`
  flex-direction: column;
`;
